import { Injectable } from "@angular/core";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { of } from "rxjs";
import { PlanTierService } from "../plan-tier/plan-tier.service";
import { UpgradeModalComponent } from "./upgrade-modal.component";

@Injectable()
export class UpgradeModalService {
  constructor(
    private planTierService: PlanTierService,
    public modalService: NgbModal,
  ) {}

  public open($event: any, toTier?: number) {
    // toTier is optional. Normally we want to show content for the next tier
    // up but occasionally we want to show a specific tier.
    const tierObservable = toTier
      ? of(toTier - 1)
      : this.planTierService.tier();

    let upgradeUrl = "/account/plan/edit";
    let feature: any;

    if ($event && $event.target.dataset.feature) {
      feature = $event.target.dataset.feature;
      upgradeUrl = `${upgradeUrl}?feature=${feature}`;
    }

    tierObservable.subscribe((tier: number) => {
      this.showModalForTier(tier + 1, upgradeUrl);
    });
  }

  private showModalForTier(toTier: number, upgradeUrl: string) {
    const modalRef = this.modalService.open(UpgradeModalComponent, {
      size: "lg",
    });
    modalRef.componentInstance.toTier = toTier;
    modalRef.componentInstance.upgradeUrl = upgradeUrl;
  }
}
